import supabase from "./supabase.js";
import {queryClient} from "./reactQueryClient.js";

export async function login({ email, password }) {
    const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
    });

    if (error) {
        console.error("Login error:", error);
        return null;
    }

    const userId = data.user?.id;
    if (!userId) {
        console.error("No user ID returned.");
        return null;
    }

    const { data: userProfile, error: profileError } = await supabase
        .from('users')
        .select(`
            role_id,
            roles(name)
        `)
        .eq('id', userId)
        .single();

    if (profileError) {
        console.error("Profile fetch error:", profileError);
        return null;
    }

    await queryClient.invalidateQueries({ queryKey: ["user"] });

    return {
        id: data.user.id,
        email: data.user.email,
        role_id: userProfile.role_id,
        role: userProfile.roles?.name,
        session: data.session
    };
}


export async function getCurrentUser() {
    const { data: sessionData } = await supabase.auth.getSession();
    const session = sessionData.session;

    if (!session) return null;

    const { data: authUser, error: userError } = await supabase.auth.getUser();
    if (userError || !authUser?.user) {
        console.error("Auth error:", userError);
        return null;
    }

    const userId = authUser.user.id;

    const { data: userProfile, error: profileError } = await supabase
        .from('users')
        .select(`
            role_id,
            roles(name)
        `)
        .eq('id', userId)
        .single();

    if (profileError) {
        console.error("Profile error:", profileError);
        return null;
    }

    return {
        id: authUser.user.id,
        email: authUser.user.email,
        role_id: userProfile.role_id,
        role: userProfile.roles?.name
    };
}



export async function logout() {
    const { error } = await supabase.auth.signOut();
    if (error) {
        console.error("Logout error:", error);
        return null;
    }

    await queryClient.invalidateQueries({ queryKey: ["user"] });
    return true;
}

export async function signup({ fullName, email, password }) {


    supabase.auth.onAuthStateChange((event, session) => {
        console.log('Auth event:', event);
        console.log('Session:', session);
    });
    
    const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
            data: {
                fullName
            },
        },
    });
    
    if (error) {
        console.error('Supabase error:', error);
        alert(`Sign-up failed: ${error.message}`);
    }

    return data;
}



export async function updateCurrentUser({ password, fullName }) {
    // 1. Update password OR fullName
    let updateData;
    if (password) updateData = { password };
    if (fullName) updateData = { data: { fullName } };

    const { data, error } = await supabase.auth.updateUser(updateData);

    if (error) throw new Error(error.message);

    // 3. Update avatar in the user
    const { data: updatedUser, error: error2 } = 
        await supabase.auth.updateUser({});

    if (error2) throw new Error(error2.message);
    return updatedUser;
}
